import { useOutletContext } from "react-router-dom";
import DataSourcesView from "../../components/adminDashboard/ui/data/DataSourcesView.jsx";

export default function DataSources() {
  const {
    companiesData,
    selectedDataCompanyId,
    setSelectedDataCompanyId,
    triggerToast,
  } = useOutletContext();
  return (
    <DataSourcesView
      companies={companiesData}
      selectedId={selectedDataCompanyId}
      setSelectedId={setSelectedDataCompanyId}
      triggerToast={triggerToast}
    />
  );
}
